let Missions = {
    lock: false,
    fetchingCategories: false,
    loadingCategory: false,
    initializing: false,
    historyLoading: false,
    renderLoadingProgress : (text) => {
        return `
            <div class="message blue">${text}</div>
        `;
    },
    renderCategory: (categories) => {
        let interface_ui = "";

        categories.map(category => {

            let alert = "";

            if (category.archived) {
                alert = `
                <div class="rewards_alert-progress grey">
                    <div class="icon mr-1"><span class="glyphicons glyphicons-lock"></span></div>
                    <div class="status-text">Esta categoría está bloqueada.</div>
                </div>
              `;
            } else {
                let start_at_flag = false;

                if (category.options?.start_at) {
                    alert = `
                     <div class="rewards_alert-progress orange">
                        <div class="icon mr-1"><span class="glyphicons glyphicons-lock"></span></div>
                        <div class="status-text">Disponible a partir del 09 de diciembre del 2021 00:05 (HPE)</div>
                    </div>
                  `;
                    start_at_flag = true;
                }

                if (category.options?.enabled===false) {
                    alert = `
                     <div class="rewards_alert-progress orange">
                        <div class="icon mr-1"><span class="glyphicons glyphicons-lock"></span></div>
                        <div class="status-text">No disponible temporalmente.</div>
                    </div>
                  `;
                    start_at_flag = true;
                }

                if (category.completed) {
                    alert = `
                    <div class="rewards_alert-progress green">
                        <div class="icon mr-1"><span class="glyphicons glyphicons-crown"></span></div>
                        <div class="status-text">¡Bien hecho! Ya has completado todas las misiones de esta categoría.</div>
                    </div>
                  `;
                } else {
                    if (!start_at_flag) {
                        alert = `
                        <div class="rewards_alert-progress red">
                            <div class="icon mr-1"><span class="glyphicons glyphicons-triangle-alert"></span></div>
                            <div class="status-text">¡Tu puedes! Aún tienes misiones pendientes de completar para esta categoría.</div>
                        </div>
                      `;
                    }
                }

            }

            interface_ui += `
            <div class="rewards_category-container ${category.options.color}">
                <a href="/missions/category/${category.slug}" class="rewards_category-image">
                    <img src="${category.options.image}" alt="${category.name}">
                </a>
                <div class="rewards_category-information">
                    <div class="rewards_category-information-container">
                        <a href="/missions/category/${category.slug}" class="title">${category.name}</a>
                        <div class="description">${category.options?.description ? category.options.description : "Sin descripción."}</div>
                    </div>
                    <div class="rewards_progress-current">
                        ${alert}
                    </div>
                </div>
            </div>
         `;
        });

        return interface_ui;
    },

    fetchCategories :  () => {
        if (!Missions.fetchingCategories) {
            Missions.fetchingCategories = true;
            let container = document.getElementById("categories_container");
            container.innerHTML = Missions.renderLoadingProgress("Estamos cargando las categorias... ¡Un momento!");
            Api.get('/reward/categories', {}, (r) => {
                if (r.success) {
                    if (r.data.length > 0) {
                        container.innerHTML = Missions.renderCategory(r.data);
                    }
                }
            });
            Missions.fetchingCategories = false;
        }
    },

    renderPrizes: (prizes) => {
        let returnData = "";

        if (prizes.coins>0) {
            returnData += `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #26c281;padding:5px;border-radius: 8px;margin-right: 5px;">
                    <span class="glyphicons glyphicons-coins"></span> ${prizes.coins} tium(s)
                </div>
            `;
        }

        if (prizes.afro>0) {
            returnData += `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #26c281;padding:5px;border-radius: 8px;margin-right: 5px;">
                    <span class="glyphicons glyphicons-tree-deciduous"></span> ${prizes.afro/86400} día(s) del Club Afro
                </div>
            `;
        }

        if (prizes.exp>0) {
            returnData += `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #26c281;padding:5px;border-radius: 8px;margin-right: 5px;">
                    <span class="glyphicons glyphicons-star"></span> ${prizes.exp} punto(s) de experiencia
                </div>
            `;
        }

        if (prizes.ach>0) {
            returnData += `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #26c281;padding:5px;border-radius: 8px;margin-right: 5px;">
                    <span class="glyphicons glyphicons-certificate"></span> ¡Logro: ${prizes.achievement}!
                </div>
            `;
        }

        if (prizes.icon && prizes.icon!==0) {
            returnData += `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #26c281;padding:5px;border-radius: 8px;margin-right: 5px;">
                    <span class="glyphicons glyphicons-diamond"></span> Icono: <img src="${prizes.icon}" style="width:18px;" alt="Icon" />
                </div>
            `;
        }

        if (prizes.full) {
            returnData += `

            `;
        }

        return returnData;
    },

    renderMission: (mission) => {

        let containerHTML = "";
        let prizes = `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #ec644b;padding:5px;border-radius: 8px;margin-right: 5px;">
                    ¡No hay ningún premio definido para esta misión! <span class="glyphicons glyphicons-user-alert"></span>
                </div>
            `;

        if (Object.keys(mission.level.extra.prizes).length>0) {
            prizes = Missions.renderPrizes(mission.level.extra.prizes);

        }

        let level = `Nivel: ${mission.level.levels.current}/${mission.level.levels.max}`;

        let description = mission.level.extra.texts.description;

        let button = ` <button class="button green big ${mission.level.requirements ? "" : "disabled"}" onclick="Missions.exchange('${mission.level.extra.token}');"><span class="glyphicons glyphicons-hand-open"></span> Reclamar</button>`;

        if (mission.level.levels.nextLevel===999) {
            level = `<span class="glyphicons glyphicons-fire"></span> Nivel máximo`;
            description = `¡Ya has completado todos los niveles de esta misión!`;
            button = ``;
        }

        if (mission.level.extra.enabled==="0") {
            button = ``;
        }

        containerHTML += `
                <div id="mission_${mission.name}" class="rewards_mission-container" style="display:flex;flex-direction: column;background-color: #ececec;padding:10px;border-radius: 5px;margin-bottom: 5px;">
                    <div class="rewards_mission-data">
                        <div class="title-data" style="display: flex;justify-content: space-between;align-items: center;">
                            <div class="title" style="font-weight: 700;font-size: 16px;">${mission.level.extra.texts.name}</div>
                            <div class="level-indicator" style="padding: 5px;border-radius: 5px;font-size: 10px;font-weight: 700;color:white;background-color: #eb9532">
                                ${level}
                            </div>
                        </div>
                        <div class="description" style="font-size: 12px;">
                            ${description}
                        </div>
                    </div>
                    <div class="rewards_prizes-data" style="display: grid;grid-template-columns: 1fr 150px;justify-content: space-between;align-items: center;">
                        <div class="rewards_prizes" style="display: flex;align-items: center;flex-wrap: wrap">
                            ${prizes}
                        </div>
                        ${button}
                    </div>
                </div>
            `;
        return containerHTML;
    },

    renderMissions: (missions) => {

        let containerHTML = "";

        missions.map(mission => {
            containerHTML += Missions.renderMission(mission)
        });

        return containerHTML;

    },

    fetchCategory: (slug) => {
        if (!Missions.loadingCategory) {
            let container = document.getElementById("category-head-container");
            let mission_container = document.getElementById("missions-container");
            Missions.loadingCategory = true;
            container.innerHTML = Missions.renderLoadingProgress("Estamos cargando los datos de la categoría...");
            mission_container.innerHTML = Missions.renderLoadingProgress("¡Un momento! Estamos cargando las misiones.");
            Api.get('/reward/getRewardsUsingCategory', {category: slug}, (r) => {
                if (r.success) {
                    container.innerHTML = `
                    <div class="rewards_category-container-detail ${r.category.options.color}">
                        <div class="rewards_category-icon">
                            <img src="${r.category.options.image}" alt="${r.category.name}">
                        </div>
                        <div class="rewards_category-data-info">
                            <div class="title">Categoría: ${r.category.name}</div>
                            <div class="description">${r.category.options.description}</div>
                        </div>
                    </div>
                    <div class="rewards_progress-bar-bottom">
                        <div class="progress" style="width: ${r.category.progress}%;"></div>
                    </div>
                `;

                    if (r.missions.length>0) {
                        mission_container.innerHTML = Missions.renderMissions(r.missions);
                    } else {
                        mission_container.innerHTML = Missions.renderLoadingProgress("¡No hay misiones disponibles en este momento para esta categoría!");
                    }
                }
            });
            Missions.loadingCategory = false;
        }
    },

    getProgress: (force = false) => {
        if (!Missions.initializing) {
            Missions.initializing = true;
            let container = document.getElementById("progressRewards");
            container.innerHTML = Missions.renderLoadingProgress("Estamos calculando tu progreso...");
            Api.get('/reward/getProgress', {}, (r) => {
                if (r.success) {
                    container.innerHTML = `
                        <div class="rewards_progress-bar">
                            <div class="rewards_progress-text">${r.already_clear} de ${r.total} <span class="glyphicons glyphicons-refresh" style="margin-left: 5px;" onclick="Missions.getProgress(true);"></span></div>
                            <div id="progress_bar_fill" class="rewards_progress-indicator" style="width: ${r.percent}%;"></div>
                        </div>
                   `;
                }
            });

            if (force) {
                setTimeout(() => {
                    Missions.initializing = false;
                }, 5000);
            } else {
                Missions.initializing = false;
            }
        }
    },

    updateHTMLMission: (mission_name,mission) => {
        let container = document.getElementById(`mission_${mission_name}`);
        let containerHTML = "";
        let prizes = `
                <div class="prize" style="font-weight:700;font-size: 10px;color:white;background-color: #ec644b;padding:5px;border-radius: 8px;margin-right: 5px;">
                    ¡No hay ningún premio definido para esta misión! <span class="glyphicons glyphicons-user-alert"></span>
                </div>
            `;

        if (Object.keys(mission.extra.prizes).length>0) {
            prizes = Missions.renderPrizes(mission.extra.prizes);

        }

        let level = `Nivel: ${mission.levels.current}/${mission.levels.max}`;

        let description = mission.extra.texts.description;

        let button = ` <button class="button green big ${mission.requirements ? "" : "disabled"}" onclick="Missions.exchange('${mission.extra.token}');"><span class="glyphicons glyphicons-hand-open"></span> Reclamar</button>`;

        if (mission.levels.nextLevel===999) {
            level = `<span class="glyphicons glyphicons-fire"></span> Nivel máximo`;
            description = `¡Ya has completado todos los niveles de esta misión!`;
            button = ``;
            Missions.fetchCategory(`${mission.extra.slug}`);
        }

        containerHTML += `
            <div class="rewards_mission-data">
                <div class="title-data" style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="title" style="font-weight: 700;font-size: 16px;">${mission.extra.texts.name}</div>
                    <div class="level-indicator" style="padding: 5px;border-radius: 5px;font-size: 10px;font-weight: 700;color:white;background-color: #eb9532">
                        ${level}
                    </div>
                </div>
                <div class="description" style="font-size: 12px;">
                    ${description}
                </div>
            </div>
            <div class="rewards_prizes-data" style="display: grid;grid-template-columns: 1fr 150px;justify-content: space-between;align-items: center;">
                <div class="rewards_prizes" style="display: flex;align-items: center;flex-wrap: wrap">
                    ${prizes}
                </div>
                ${button}
            </div>
        `;
        container.innerHTML = containerHTML;
    },
    exchange: function(token_secret) {
        if (!Missions.lock) {
            Missions.lock = true;
            Api.post('/reward/exchange', {token: token_secret}, function(i) {
                if (i.success) {
                    Alert.push([{type: 'success', text: 'La misión se ha sido completado exitosamente.', icon: 'circle-check'}]);
                    Missions.updateHTMLMission(i.mission, i.level);
                } else {
                    switch(i.error.identifier) {
                        case 'reward_not_found':
                            Alert.push([{type: 'danger', text: '¡Oops! La recompensa que intentas reclamar no existe.', icon: 'triangle-alert'}]);
                            break;
                        case 'reward_not_enabled':
                            Alert.push([{type: 'danger', text: '¡Oops! La recompensa que intentas reclamar no está disponible.', icon: 'triangle-alert'}]);
                            break;
                        case 'account_required_level_fail':
                            Alert.push([{type: 'danger', text: '¡Oops! No cuentas con el nivel requerido para esta recompensa.', icon: 'triangle-alert'}]);
                            break;
                        case 'already_rewarded':
                            Alert.push([{type: 'danger', text: '¡Oops! Ya has reclamado esta recompensa.', icon: 'triangle-alert'}]);
                            break;
                        case 'account_doesnt_have_requirements':
                            Alert.push([{type: 'danger', text: '¡Oops! No cuentas con todos los requisitos necesarios.', icon: 'triangle-alert'}]);
                            break;
                        case 'account_doesnt_have_all_requirements':
                            Alert.push([{type: 'danger', text: '¡Oops! No cuentas con todos los requisitos necesarios.', icon: 'triangle-alert'}]);
                            break;
                        case 'reward_undefined_in_engine':
                            Alert.push([{type: 'danger', text: '¡Oops! Esta recompensa no está definida.', icon: 'triangle-alert'}]);
                            break;
                        case 'error_to_check_reward_level':
                            Alert.push([{type: 'danger', text: '¡Oops! Ha ocurrido un error al verificar tu progreso.', icon: 'triangle-alert'}]);
                            break;
                        case 'reward_doesnt_have_previousLevel':
                            Alert.push([{type: 'danger', text: '¡Oops! No tienes el nivel necesario para esta recompensa.', icon: 'triangle-alert'}]);
                            break;
                        case 'account_doesnt_have_past_level':
                            Alert.push([{type: 'danger', text: '¡Oops! Ha ocurrido un error con la recompensa..', icon: 'triangle-alert'}]);
                            break;
                        case 'account_doesnt_have_all_effects':
                            Alert.push([{type: 'danger', text: '¡Oops! No posees todos los efectos requeridos.', icon: 'triangle-alert'}]);
                            break;
                    }
                }
                Missions.lock = false;
            });
        }
    },
    renderHistoryEntry: (data) => {
      let entries = "";

      data.map(element => {
        entries += `
            <div class="rewards_history-container" style="display: flex;flex-direction: column;padding: 5px;background-color: #eeeeee;border-radius: 5px;margin-bottom: 5px;">
                <div class="title" style="display: flex;align-items: center;justify-content: space-between;width: 100%;"><p style="font-weight: 700;font-size: 14px;">${element.name}</p> <div class="reward_level" style="padding-left: 5px;padding-right:5px;font-size: 10px;color:white;background-color: #f9690e;border-radius: 8px;font-weight: 700;">Nivel: <span class="glyphicons glyphicons-star"></span> ${element.level}</div></div>
                <div class="date" style="font-size: 12px;color:#6c7a89">Conseguida: ${element.created_at}</div>
            </div>
        `;
      });
      return entries;
    },
    getHistory: () => {
        if (!Missions.historyLoading) {
            Missions.historyLoading = true;
            let container = document.getElementById("history_container");
            container.innerHTML = Missions.renderLoadingProgress("Estamos cargando tu historial de misiones...");
            Api.get('/reward/getHistory', {}, (r) => {
               if (r.success) {
                    if (r.data.length>0) {
                        container.innerHTML = Missions.renderHistoryEntry(r.data);
                    } else {
                        container.innerHTML = Missions.renderLoadingProgress("No has completado ninguna misión.");
                    }
               }
            });
            Missions.historyLoading = false;
        }
    }
}

//[{"function":"checkHabboHasClothe","param":["ha","4422"],"extradata": "Sombrero Estrella Rojo Rubí", "sequence": true}]
